import { render, staticRenderFns } from "./CandlestickChart.vue?vue&type=template&id=6f8677c8&scoped=true&"
import script from "./CandlestickChart.vue?vue&type=script&lang=js&"
export * from "./CandlestickChart.vue?vue&type=script&lang=js&"
import style0 from "./CandlestickChart.vue?vue&type=style&index=0&id=6f8677c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8677c8",
  null
  
)

export default component.exports